<template>
    <div class="d-flex justify-content-between">
        <QuestionWeight :template="template" type="slides"/>
        <span @click="clearHandler" class="reset-data-btn">Reset All</span>
    </div>
    <div class="d-flex flex-column h-100 justify-content-start my-3 gap-4">
        <form class="form-container row m-0 d-flex flex-column justify-content-between">
            <div class="d-flex flex-column gap-2 justify-content-between content-container">
                <NameComponent :name="template.questions.slides" lable="Case Subject"
                               :inputHandler="slidesQuestionValidation"
                               :err="template?.questions?.slides?.errors['name']"/>

                <DescriptionComponent :description="template.questions.slides"
                                      :inputHandler="slidesQuestionValidation"
                                      type=""
                                      :lable="'Case Description'"
                                      :err="template?.questions?.slides?.errors['description']"/>
            </div>
        </form>
        <div class="content-container">
            <div class="d-flex justify-content-between">
                <div>
                    Add Material
                </div>
                <div class="err" v-if="errors['slides'].length > 0">
                    <div v-for="msg in errors['slides']" class="text-danger">{{msg}}</div>
                </div>
                <div v-if="template.questions.slides.images.length > 0">
                    <label for="file-upload" class="custom-file-upload">Upload Images</label>
                    <input id="file-upload" type="file" class="d-none" multiple
                           :accept="acceptedTyps" @input="handleFiles"/>
                </div>
            </div>

            <div class="d-flex p-4" v-if="template.questions.slides.images.length === 0">
                <div class="add-material-info-container m-auto">
                    <div>
                        <img src="../../../assets/images/file-image.svg" alt="">
                    </div>
                    <p class="add-material-info-text">No Images or PDFs Are Listed for This Case</p>
                    <label for="file-upload2" class="custom-file-upload">Upload Images</label>
                    <input id="file-upload2" type="file" class="d-none" multiple
                           :accept="acceptedTyps" @input="handleFiles"/>
                </div>
            </div>
            <div class="uploaded-images-container" v-else>
                <div v-for="(img, idx) in template.questions.slides.images" :key="idx" class="position-relative">
                    <img class="uploaded-image"
                         :src="opType === 'update' ? !isBase64(img.path) ? s3pathThumb +  img.path : img.path : img.path"
                         alt="">
                    <span class="img-delete-icon" @click="deleteImageHandler($event, idx)">
                         <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column gap-3 content-container">
            <div>Add Category</div>
            <div class="input-category-container">
                <!--                <label for="inputName" class="form-label custom-category-label m-0">Category Name</label>-->
                <div class="d-flex gap-2">

                    <div class="input-container">
                        <label for="inputName" class="form-label custom-category-label m-0">Category Name</label>
                        <input type="text"
                               class="custom-category-input form-control"
                               id="inputName"
                               @input="categoryNameHandler($event, 'categoryName')"
                               placeholder="Category Name"
                               autocomplete="off"
                               v-model="categoryName"
                        >

                    </div>
                    <div class="align-self-end" @click="addCategoryHandler">
                        <span class="add-question align-self-end">+</span>
                    </div>
                </div>
                <div class="err" v-if=" template.questions.slides.errors['categoryName'].length > 0">
                    <div v-for="msg in  template.questions.slides.errors['categoryName']" class="text-danger">{{msg}}
                    </div>
                </div>


            </div>
            <div v-if="template.questions.slides.category.length > 0" class="category-content">
                <div class="category-content-images">
                    <p class="uploaded-image-title">Uploaded Images</p>
                    <div class="category-content-images-container">
                        <div v-if="template.questions.slides.images.length > 0"
                             v-for="(img, idx) in template.questions.slides.images"
                             :key="idx"
                             class="position-relative"
                        >

                             <span class="position-absolute maximize-img"
                                   @click="maximizeImageHandler($event, img.path)">
                         <font-awesome-icon :icon="['fas', 'eye']" size="sm"/>
                    </span>

                            <span
                                    @mouseenter="moveMouseEnterHandelr($event, img.id)"
                                    @mouseleave="moveMouseLeaveHandelr($event, img.id)"
                                    draggable="true"
                                    @dragstart="dragStartHandler($event, img.id, idx)"

                                    @touchmove="touchHandler($event, img.id, idx, true)"
                                    @touchend="touchHandler($event, img.id, idx, false)"
                                    :id= "'icon-'+ img.id"
                                    class="position-absolute move-img">
                         <font-awesome-icon :icon="['fas', 'hand-point-up']" size="sm"/>
                    </span>
                            <div class="overlay-img" style="display: none" :id= "'overlay-'+ img.id"></div>
                            <img width="148" class="drag-img-style" height="83"
                                 :id= "'img-'+ img.id"
                                 :src="opType === 'update' ?  !isBase64(img.path) ? s3pathThumb +  img.path : img.path : img.path"
                                 alt="">
                        </div>
                        <div v-else>
                            <p>No Images Or PDFs</p>
                        </div>
                    </div>

                </div>
                <div class="category-content-categories">
                    <div v-if="template.questions.slides.category.length > 0">
                        <div class="category-container my-4"
                             v-for="(category, catIdx) in template.questions.slides.category"
                             :key="catIdx">
                            <span v-if="template.questions.slides.category.length > 1" class="category-delete-icon"
                                  @click="deleteCategoryHandler($event, catIdx)">
                                <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                            </span>
                            <div class="d-flex gap-3">
                                <div class="show-slide">
                                    <p class="category-name">{{category.name}}</p>

                                    <div class="d-flex justify-content-between">
                                        <div class="category-slides-container">
                                            <div class="position-relative" v-for="(img, imgIdx) in category.images"
                                                 :key="imgIdx"

                                                 draggable="true"
                                                 @dragstart="dragStartHandler($event, img.id, idx)"

                                                 @touchmove="touchHandler($event, img.id, idx, true)"
                                                 @touchend="touchHandler($event, img.id, idx, false)"

                                                 @drop="dropHandler($event, catIdx, imgIdx)"
                                                 @dragenter.prevent
                                                 @dragover.prevent>
                                                <img class="slide-img" :id='"img-"+catIdx+"-"+imgIdx' width="147"
                                                     height="83"
                                                     :src="
                                                     imagesRef[+img.id] == undefined ? require(`../../../assets/images/defultSlide.svg`) :
                                                     img.path === 'defultSlide.svg' ? require(`../../../assets/images/${img.path}`) :

                                                    opType === 'update' ?  !isBase64(imagesRef[+img.id]) ? s3pathThumb +  img.path : imagesRef[+img.id] :  imagesRef[+img.id]"
                                                     alt="">

                                                <span v-if="category.images.length > 1" class="img-delete-icon"
                                                      @click="deleteSlideImageHandler($event, catIdx,imgIdx )">
                                                    <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="align-self-start add-slide" @click="addSlideHandler($event, catIdx)">
                                    <span class="add-question align-self-end">+</span>
                                </div>
                            </div>

                            <div class="err" v-if="template.questions.slides.category.length > 0">
                                <div v-for="msg in  template.questions.slides.category[catIdx].error"
                                     class="text-danger">{{msg}}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-else>No categories</div>
                </div>
            </div>

            <div class="d-flex p-4" v-else>
                <div class="add-material-info-container w-100">
                    <div>
                        <img src="../../../assets/images/catDafault.svg" alt="">
                    </div>
                    <p class="add-material-info-text">No Categories Are Listed for This Case</p>
                </div>
            </div>
        </div>
    </div>

    <ShowImageModal v-if="showImgModal" :imagePath="imagePath" @close-modal="showImgModal = false"/>
    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>


<script>
    import {toRef, ref, defineAsyncComponent, onMounted} from "vue";
    import QuestionWeight from "../../components/QuestionWeight";
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import NameComponent from "../../components/templateComponents/nameComponent";
    import DescriptionComponent from "../../components/templateComponents/descriptionComponent";
    import store from "../../../store";

    import getBrowserType from "../../../helpers/getBrowserType";

    const ShowImageModal = defineAsyncComponent(() =>
        import ('../../components/ShowImageModal')
    );
    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );

    import {logger} from "../../../helpers/logger"

    // const pdfjsLib = require('pdfjs-dist/build/pdf');
    // require('pdfjs-dist/legacy/build/pdf.worker')

    // const PDFJS = window['pdfjs-dist/build/pdf'];
    // const PDFJS = window['pdfjs-dist/build/pdf'];
    const PDFJS = pdfjsLib;
    // const PDFJS = require('../../../assets/pdfJS/pdfLib');
    // The workerSrc property shall be specified.
    // PDFJS.workerSrc =  require('pdfjs-dist/build/pdf.worker');
    // PDFJS.GlobalWorkerOptions.workerSrc =  require('pdfjs-dist/legacy/build/pdf.worker');
    export default {
        name: 'app',
        props: {
            template: Object,
            opType: String
        },
        components: {DescriptionComponent, NameComponent, QuestionWeight, ShowImageModal, ConfirmationModal},

        setup(props, context) {

            const confirmFlag = ref(false);
            const confirmMsg = ref('');
            const isMoving = ref(false);

            const template = toRef(props, 'template');
            const opType = toRef(props, 'opType');

            const previewSlides = ref([]);

            const categoryName = ref('');
            const insertedCategoryName = ref([]);
            const showImgModal = ref(false);
            const imagePath = ref('');
            const s3pathImage = ref("https://dk703uarlyapi.cloudfront.net/images");

            const browserType = ref('');
            const acceptedTyps = ref([]);
            const imagesRef = ref({});

            const errors = ref({
                name: [],
                description: [],
                slides: [],
                categoryName: []
            });

            onMounted(async () => {
                browserType.value = getBrowserType();

                template.value.questions.slides.images.forEach((img) => {
                    console.log({img})
                    imagesRef.value[img.id] = img.path;
                })

                if (browserType.value !== 'safari') { //
                    acceptedTyps.value = ['application/pdf', 'image/*'];
                } else {
                    acceptedTyps.value = ['image/*'];
                }
            });
            const handleFiles = async (data) => {
                // PDFJS.disableWorker = true;
                console.log('files', data.target.files);
                await store.dispatch('setIsLoading', true);
                Array.from(data.target.files).forEach((d) => {

                    console.log({d})
                    if (d.type === "application/pdf") {

                        if (browserType.value !== 'safari') {
                            const docName = d.name;
                            const blob = new Blob([d], {
                                type: 'application/pdf' // this is the only MIME for SVG
                            });
                            PDFJS.getDocument({
                                url: URL.createObjectURL(blob)
                            }).promise.then(async (doc) => {
                                for (let p = 1; p <= doc.numPages; p++) {
                                    console.log({p})
                                    doc.getPage(p).then((page) => {

                                        let scale = 1.5;
                                        let viewport = page.getViewport({scale: scale});
                                        //
                                        let canvas = document.createElement('canvas');

                                        // Prepare canvas using PDF page dimensions
                                        let context = canvas.getContext('2d');
                                        canvas.height = viewport.height;
                                        canvas.width = viewport.width;

                                        // Render PDF page into canvas context
                                        let renderContext = {canvasContext: context, viewport: viewport};
                                        let renderTask = page.render(renderContext);

                                        renderTask.promise.then(() => {
                                            let base64str = null;
                                            let decoded = null;

                                            const imgData = {'id': Date.now(), 'path': canvas.toDataURL('image/png')};

                                            base64str = canvas.toDataURL('image/png').substr(22);
                                            decoded = atob(base64str);
                                            if (decoded.length < 5000000) {
                                                if (template.value.questions.slides.images.length < 30) {
                                                    console.log("FileSize: " + decoded.length);
                                                    imagesRef.value[imgData.id] = imgData.path;
                                                    template.value.questions.slides.images.push(imgData)
                                                    previewSlides.value = [...template.value.questions.slides.images];
                                                    errors.value['slides'] = []

                                                } else {
                                                    errors.value['slides'] = ['* slides number must be less than 30 slide']
                                                }
                                            } else {
                                                errors.value['slides'].push(`slide number ${p} must be less than 5MB `)
                                            }


                                            checkCategoryImages();
                                            // console.log(template.value.questions.slides.images.length + ' page(s) loaded in data')
                                        });
                                    });

                                }
                                await store.dispatch('setIsLoading', false);
                            }).catch(function (error) {
                                store.dispatch('setIsLoading', false);
                                console.log(error.message);
                                errors.value['slides'] = [`* ${error.message} `]
                            });
                        } else {
                            store.dispatch('setIsLoading', false);
                            errors.value['slides'] = ['* you can\'t upload pdfs ']
                        }

                    } else {
                        if (d.size <= 10000000) {
                            const reader = new FileReader();
                            reader.onload = function (e) {
                                const imgData = {'id': Date.now(), 'path': e.target.result};
                                console.log(e.target)
                                if (template.value.questions.slides.images.length < 30) {
                                    template.value.questions.slides.images.push(imgData);
                                    imagesRef.value[imgData.id] = imgData.path;

                                    console.log("imagesRef => ", imagesRef.value)
                                    previewSlides.value = [...template.value.questions.slides.images];
                                    errors.value['slides'] = []
                                } else {
                                    errors.value['slides'] = ['*slides number must be less than 30 slide']
                                }
                                checkCategoryImages();

                            };
                            reader.readAsDataURL(d);
                            reader.onloadend = store.dispatch('setIsLoading', false);
                        } else {
                            store.dispatch('setIsLoading', false)
                            errors.value['slides'].push(`Image must be less than 10MB `)

                        }

                    }
                });
            };

            const deleteImageHandler = (e, idx) => {
                console.log("eds")
                const imgId = template.value.questions.slides.images[idx]['id'];

                let err = null;



                // previewSlides.value = previewSlides.value.filter((slide) => slide.id !== imgId);
                template.value.questions.slides.images.splice(idx, 1);
                delete imagesRef.value[imgId];
                if (template.value.questions.slides.images.length < 30) {
                    errors.value['slides'] = []
                }else {
                    errors.value['slides'] = ['*slides number must be less than 30 slide']
                }
                template.value.questions.slides.category.forEach((cat) => {

                    cat.images.filter((slide) => slide.id !== imgId)
                    cat.images.forEach((img) => {
                        if (img['id'] == imgId) {
                            img['id'] = Date.now()
                            img['path'] = 'defultSlide.svg'
                        }

                        err = img['path'] === 'defultSlide.svg';
                    })

                    if (err) {
                        cat.error = template.value.questions.slides.images.length > 0 ? ['*Required'] : ['*You must insert images'];
                        err = false;
                    }




                });

                slidesQuestionValidation();
            };

            const deleteSlideImageHandler = (e, catIdx, slideImgidx) => {
                template.value.questions.slides.category[catIdx].images.splice(slideImgidx, 1);
                if (template.value.questions.slides.images.length < 30) {
                    errors.value['slides'] = []
                }else {
                    errors.value['slides'] = ['*Slides number must be less than 30 slide']
                }
                slidesQuestionValidation();
            };

            const deleteCategoryHandler = (e, idx) => {
                template.value.questions.slides.category.splice(idx, 1);
                slidesQuestionValidation();
            };

            const addCategoryHandler = () => {

                const isError = template.value.questions.slides.errors['categoryName'].length > 0;
                const isName = categoryName.value === '';
                let err = null;

                const isImages = template.value.questions.slides.images.length > 0;
                let insertedData = null;

                if ((!isError) && (!isName)) {
                    if (!insertedCategoryName.value.includes(categoryName.value)) {
                        insertedData = isImages ? {
                            name: categoryName.value, images: [{
                                'id': Date.now(),
                                'path': 'defultSlide.svg'
                            },], error: ['*Required']
                        } : {
                            name: categoryName.value, images: [{
                                'id': Date.now(),
                                'path': 'defultSlide.svg'
                            }], error: ['* you must insert images']
                        };
                        insertedCategoryName.value.push(categoryName.value);
                        template.value.questions.slides.category.push(insertedData);
                        categoryName.value = '';
                    } else {
                        template.value.questions.slides.errors['categoryName'] = ['*Category name must be unique'];
                    }
                } else if (isName) {
                    template.value.questions.slides.errors['categoryName'] = ['*Required'];
                }


                slidesQuestionValidation();


            };

            const addSlideHandler = (e, idx) => {
                console.log('addSlideHandler ', idx);
                const isImages = template.value.questions.slides.images.length > 0;

                if (isImages) {
                    template.value.questions.slides.category[idx].images.push({
                            'id': Date.now(),
                            'path': 'defultSlide.svg'
                        }
                    );
                    template.value.questions.slides.category[idx].error = []
                } else {
                    template.value.questions.slides.category[idx].error = ['* you must insert images']
                }
                slidesQuestionValidation();
            };

            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['slides'] = {
                        weight: null,
                        counter: 0,
                        title:  template.value.questions['slides']['title'],
                        isError: false,
                        name: '',
                        description: '',
                        images: [],
                        category: [],
                        errors: {
                            weight: {isError: false, message: ''},
                            name: [],
                            description: [],
                            slides: [],
                            categoryName: [],
                            categorySlides: [],
                        }
                    };

                    if (template.value.questions['slides'].counter > 0) {
                        template.value.questionsCount -= 1;
                    }
                }
            };

            const clearHandler = () => {
                template.value.questions['slides'].weight = null;

                if (template.value.questions['slides'].counter > 0 || template.value.questions['slides'].isError) {
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }

            };

            const touchHandler = (e, img,idx, isMoving = false) => {

                const id = img;
                const clientX = e.clientX || e.changedTouches[0].clientX;
                const clientY = e.clientY || e.changedTouches[0].clientY;


                if (isMoving) {

                }else{
                    let elmEnd = document.elementFromPoint(
                        clientX,
                        clientY
                    );


                    const catIdx = +elmEnd.id.split('-')[1];
                    const imgIdx = +elmEnd.id.split('-')[2];




                    if (id !== '') {
                        const img = template.value.questions.slides.images.filter((item) => {
                            if (item?.id === +id) {
                                return item?.path;
                            }
                        })

                        const path = img[0]?.path;

                        if (path !== null && path !== '') {
                            template.value.questions.slides.category[catIdx].images[imgIdx] = {
                                id: id,
                                path: path,
                                order: imgIdx + 1
                            }
                            template.value.questions.slides.category[catIdx].error = [];
                        }

                        slidesQuestionValidation();
                    }

                }
            }

            const dragStartHandler = (e, img) => {
                const id = img;
                const path = null;

                if (img !== "defultSlide.svg") {
                    // e.dataTransfer.dropEffect = 'move';
                    // e.dataTransfer.effectAllowed = 'move';
                    // e.dataTransfer.setData('img', path);
                    e.dataTransfer.setData('id', id);
                } else {
                    e.dataTransfer.setData('img', null);
                }
            };

            const dropHandler = (e, catIdx, imgIdx) => {
                e.preventDefault();

                const item = `img-${catIdx}-${imgIdx}`;
                const element = document.getElementById(item);

                // const path = e.dataTransfer.getData('img');
                const id = e.dataTransfer.getData('id');


                console.log({id})

                if (id !== '') {
                    const img = template.value.questions.slides.images.filter((item) => {
                        if (item?.id === +id) {
                            return item?.path;
                        }
                    })

                    const path = img[0]?.path;

                    if (path !== null && path !== '') {
                        template.value.questions.slides.category[catIdx].images[imgIdx] = {
                            id: id,
                            path: path,
                            order: imgIdx + 1
                        }
                        template.value.questions.slides.category[catIdx].error = [];
                        // previewSlides.value = previewSlides.value.filter((slide) => slide.id !== +id);
                    }

                    slidesQuestionValidation();
                }

            };

            const categoryNameHandler = (e, type) => {
                let enteredValue = e.target.value;
                categoryNameValidation(enteredValue, type);
            };

            const checkCategoryImages = () => {
                let err = false;
                let BreakException = {};

                template.value.questions.slides.category.forEach((cat) => {
                    cat.error = [];
                    try {
                        cat.images.forEach((img) => {
                            err = img['path'] === 'defultSlide.svg';
                            if (err)
                                throw BreakException;
                        });

                    } catch (e) {
                        if (e !== BreakException) throw e;
                        if (err) {
                            cat.error = template.value.questions.slides.images.length > 0 ? ['*Required'] : ['* you must insert images'];
                            err = true;
                        }
                    }
                });

                return err;
            };

            const checkCategoryErrors = () => {
                let err = false;
                let BreakException = {};

                template.value.questions.slides.category.forEach((cat) => {
                    try {
                        if (cat.error.length > 0) {
                            throw BreakException;
                        }
                    } catch (e) {
                        if (e !== BreakException) throw e;
                        err = true;
                    }
                });
                return err;
            };

            const categoryNameValidation = (val, type) => {
                let isError = true;
                if (val === '') {
                    template.value.questions.slides.errors[type] = ['*Required'];
                } else if (val.length < 2) {
                    template.value.questions.slides.errors[type] = ['* subject must be more than 2 characters'];
                } else if (val.length > 100) {
                    template.value.questions.slides.errors[type] = ['* input must be less than 100 characters'];
                } else {
                    isError = false;
                    template.value.questions.slides.errors[type] = [];
                }

                return isError;
            };

            const categoryDescriptionValidation = (val) => {
                let isError = true;

                if (val === '') {
                    template.value.questions.slides.errors['description'] = ['*Required'];
                } else if (val.length < 2) {
                    template.value.questions.slides.errors['description'] = ['* category description must be more than 2 characters'];
                } else if (val.length > 4294967295) {
                    template.value.questions.slides.errors['description'] = ['* category description must be shorter'];
                } else {
                    isError = false;
                    template.value.questions.slides.errors['description'] = [];
                }

                return isError;
            };

            const categoryValidation = () => {
                let isError = true;
                isError = template.value.questions.slides.category.length === 0;
                console.log("categoryValidation | error : ", isError)
                return isError;
            };

            const categorySlidesValidation = () => {
                let isError = true;

                isError = template.value.questions.slides.images.length === 0;
                console.log("categorySlidesValidation | error : ", isError)
                return isError;
            };

            const slidesQuestionValidation = () => {
                let BreakException = {};

                if (template.value.questions['slides'].weight === null) {
                    template.value.questions['slides']['errors']['weight']['isError'] = true
                    template.value.questions['slides']['errors']['weight']['message'] = '*Required'
                }

                let isErrors = {
                    name: false,
                    description: false,
                    category: false,
                    categoryItems: false,
                    categoryName: false,
                    slides: false,
                    categoryImages: false,
                };

                let slideName = template.value.questions.slides.name;
                let slideDescription = template.value.questions.slides.description;


                console.log({slideName})
                isErrors.name = categoryNameValidation(slideName, 'name');
                isErrors.description = categoryDescriptionValidation(slideDescription);
                isErrors.category = categoryValidation();
                isErrors.slides = categorySlidesValidation();
                // isErrors.categoryName =  categoryNameValidation(categoryName.value, 'categoryName');

                if (!isErrors.category) {
                    isErrors.categoryImages = checkCategoryImages();
                }

                isErrors.categoryItems = checkCategoryErrors();


                isErrors = isErrors.name || isErrors.description || isErrors.category || isErrors.categoryImages || isErrors.categoryItems;
                console.log({isErrors})
                template.value.questions['slides'].isError = isErrors;


                if (!isErrors)
                    increaseTemplateQuestions(template, 'slides');
                else
                    decreaseTemplateQuestions(template, 'slides');

                return isErrors;
            };

            const isBase64 = (path) => {

                const found = path ? path.search('data:image/') : -1;
                console.log({found})
                return found !== -1;
            };

            const maximizeImageHandler = (e, path) => {

                if (isBase64(path)) {
                    imagePath.value = path;
                } else {
                    imagePath.value = s3pathImage.value + '/' + path;
                }

                showImgModal.value = true;
                // isBase64(path);
                console.log()
            };

            const moveMouseEnterHandelr = (e, id) => {
                logger(['moveMouseEnterHandelr ', id]);
                let img = document.getElementById(`img-${id}`);
                let icon = document.getElementById(`icon-${id}`);
                let overlay = document.getElementById(`overlay-${id}`);

                overlay.style.display = 'block';
                icon.style.backgroundColor = '#000';
            };

            const moveMouseLeaveHandelr = (e, id) => {
                logger(['moveMouseLeaveHandelr ', id]);
                let img = document.getElementById(`img-${id}`);
                let icon = document.getElementById(`icon-${id}`);
                let overlay = document.getElementById(`overlay-${id}`);

                overlay.style.display = 'none';
                icon.style.backgroundColor = '#00000082';
            };

            return {
                template,
                errors,
                categoryName,
                previewSlides,
                opType,
                showImgModal,
                imagePath,
                browserType,
                acceptedTyps,
                s3pathThumb: "https://dk703uarlyapi.cloudfront.net/thumbnail/",
                s3pathImage,
                confirmFlag,
                confirmMsg,
                confirmModalHandler,
                touchHandler,
                handleFiles,
                categorySlidesValidation,
                deleteImageHandler,
                addCategoryHandler,
                addSlideHandler,
                dragStartHandler,
                dropHandler,
                categoryNameHandler,
                checkCategoryImages,
                slidesQuestionValidation,
                categoryNameValidation,
                categoryValidation,
                categoryDescriptionValidation,
                deleteSlideImageHandler,
                checkCategoryErrors,
                deleteCategoryHandler,
                isBase64,
                maximizeImageHandler,
                clearHandler,
                moveMouseEnterHandelr,
                moveMouseLeaveHandelr,
                imagesRef,
                increaseTemplateQuestions,
                decreaseTemplateQuestions,

            }
        }
    }

</script>

<style scoped>

    /*.drag-img-style {*/
    /*    cursor: move;*/
    /*}*/

    .category-delete-icon {
        top: -8px;
        right: -6px;
    }

    .img-delete-icon {
        top: 2px;
        right: 0;
    }

    .img-delete-icon,
    .category-delete-icon {
        position: absolute;

        display: flex;
        border-radius: 50%;
        width: 14.2px;
        height: 14.2px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #0e2731;
        background-color: #e95626;
        cursor: pointer;
    }


    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .add-question:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: #FFF;
        background-color: transparent;
        outline: 0;
    }

    .content-container {
        border: 1px solid #39525C;
        padding: 14px;
        border-radius: 10px;
    }

    .custom-file-upload {
        display: flex;
        justify-content: center;
        width: 172px;
        height: 44px;
        padding: 9px 24px 12px;
        border-radius: 4px;
        color: #fff;
        background-color: var(--btn-bg-color);
        cursor: pointer;
        font-family: Poppins, serif;
        font-size: 14px;
        font-weight: 500;
    }

    .add-material-info-container {
        display: flex;
        flex-direction: column;
        /*gap: 10px;*/
        justify-content: center;
        align-items: center;
        /*padding: 40px 150px;*/
        border: 1px solid #39525C;
        /*border-radius: 10px;*/
        width: 748px;
        height: 254px;
        /*margin: 15px 0 0 43px;*/
        padding: 57px 20px 40px;
        border-radius: 11px;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.16);

        /*background-color: #032a3a;*/
    }

    .add-material-info-text {
        font-family: Poppins, sans-serif;
        margin: 16px 0 21px;
        font-size: 18px;
        font-weight: 500;
    }

    .uploaded-images-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        max-height: 282px;
        min-height: 100px;
        overflow-y: auto;
        padding-left: 26px;
        margin-top: 26px;
    }

    .uploaded-image-title {
        font-family: Poppins, sans-serif;
        font-size: 17px
    }

    .uploaded-image {
        width: 120px;
        height: 120px;
        margin: 9px 3px 0 0;
        border-radius: 12px;
    }


    .input-category-container {
        height: 95px;

    }

    .custom-category-label {
        font-size: 15px;
        font-weight: 500;
    }

    .custom-category-input {
        width: 278px;
        height: 52px;
        font-size: 14px;
        font-weight: 500;
        color: var(--main-color);
    }

    .custom-category-input,
    .custom-category-input:focus,
    .custom-category-input:active {
        background-color: transparent;
        color: var(--main-color);
        border: 1px solid #39525C;
        outline: 0;
        box-shadow: 0 0 0 0
    }

    .category-content {
        display: flex;
        height: 589px;
        border: 1px solid #39525C;
        border-radius: 11px;
        padding: 27.8px 15px 27.8px 24px;
    }

    .category-content-images {
        border-right: 1px solid #e65c00;
        width: 200px;
    }

    .category-content-images-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 180px;
        height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .category-content-categories {
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 16px;
        padding-left: 25px;
        width: 100%;
    }

    .category-slides-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        max-height: 200px;
        min-height: 10px;
        overflow-y: auto
    }

    .category-name {
        font-family: Poppins, sans-serif;
        font-size: 17px;
        margin-bottom: 10px;
    }

    .add-slide {
        width: 5%;
    }

    .show-slide {
        /*width: 95%;*/
    }

    .slide-img {
        margin: 9px 3px 0 0;
        border-radius: 12px;
    }

    .category-container {
        position: relative;
        border: 1px solid #39525C;
        padding: 12px;
        border-radius: 6px;
    }

    .maximize-img {
        right: 35px;
        top: 3px;
        color: #f8f9fa;
        background-color: #0000004d;
        width: 20px;
        height: 20px;
        display: flex;
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .move-img {
        left: 56px;
        top: 25px;
        color: #f8f9fa;
        background-color: #00000082;
        width: 30px;
        height: 30px;
        display: flex;
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 1;
    }

    .overlay-img{
        background-color: #00000073;
        position: absolute;
        top: 0;
        width: 82.5%;
        height: 100%;
    }
    .err {
        height: 100px;
        overflow-y: auto;
    }
</style>